/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Connection_Error_Connection_TitleInputs */



/**
* | output |
* | --- |
* | "Check your connection" |
*
* @param {Auth_Connection_Error_Connection_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_connection_error_connection_title = /** @type {((inputs?: Auth_Connection_Error_Connection_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Connection_Error_Connection_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbindung prüfen")
	return /** @type {LocalizedString} */ ("Check your connection")
});